import React from 'react'
import { ReactComponent as ErrorIconSvg } from 'icons/field-error-icon.svg'
import SelectTimeZone from './SelectTimeZone'
import DateFnsUtils from '@date-io/date-fns'
import {
    Box,
    InputLabel,
    Typography,
    Select,
    InputBase,
    IconButton,
    MenuItem,
    styled,
} from '@mui/material'

import LocalizationProvider from '@mui/lab/LocalizationProvider'

import DatePicker from '@mui/lab/DatePicker'

const MySelect = styled(Select)(({ theme }) => ({
    '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent',
    },
}))

const MyDatePicker = styled(DatePicker)({
    maxWidth: '20.5rem',
    padding: '0 0 0.5rem',
})

const StyledInputField = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    position: 'relative',
    height: 40,
    backgroundColor: theme.palette.common.white,
    border: 'solid 1px #ebebed',
    fontSize: 16,
    padding: '10px 0px',
    '&:focus-within': {
        backgroundColor: theme.palette.common.white,
        borderRadius: 5,
        boxShadow: ` 0 2px 4px 0 rgba(48, 127, 193, 0.15)`,
        border: 'solid 1px #0057A0',
    },
}))

const StyledLabel = styled(Typography)({
    color: '#b4b4b4',
    padding: '0 1rem 1rem 1rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
})

const StyledIconButton = styled(IconButton)({
    padding: '1rem',
})

const StyledInputBase = styled(InputBase)(({ theme, style }) => ({
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    flex: 1,
    width: style && style.width ? style.width : 'auto',
    '&:before': {
        borderBottom: '0px !important',
        borderColor: 'transparent !important',
    },
}))

export default function CustomizedInputBase({
    label,
    name,
    value,
    error,
    single,
    select,
    selectTimeZone,
    disabled,
    date,
    onChange,
    style,
    options = [],
}) {
    const fieldId = `custom-field-${name || label}`

    const InputField = (
        <StyledInputField style={{ border: error && '1px solid #ff0000' }}>
            {select && (
                <MySelect
                    autoComplete="off"
                    onChange={onChange}
                    value={value}
                    name={name}
                    id={fieldId}
                    placeholder={label}
                    input={<StyledInputBase />}
                    disabled={disabled}
                >
                    {options.map((item) => (
                        <MenuItem value={item} key={item}>
                            {item}
                        </MenuItem>
                    ))}
                </MySelect>
            )}
            {single && (
                <StyledInputBase
                    autoComplete="off"
                    name={name}
                    id={fieldId}
                    value={value ? value : ''}
                    onChange={onChange}
                    inputProps={{ 'aria-label': label }}
                    placeholder={label}
                    fullWidth={style.width ? false : true}
                    disabled={disabled}
                />
            )}
            {selectTimeZone && (
                <SelectTimeZone onChange={onChange} value={value} />
            )}
            {date && (
                <LocalizationProvider utils={DateFnsUtils}>
                    <MyDatePicker
                        autoOk
                        disableToolbar
                        inputVariant="standard"
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="normal"
                        maxDate={Date.parse('01-01-2200')}
                        value={value ? Date.parse(value) : null}
                        onChange={onChange}
                        disabled={disabled}
                        InputProps={{
                            inputProps: {
                                'aria-label': label,
                            },
                        }}
                    />
                </LocalizationProvider>
            )}

            {error && (
                <StyledIconButton
                    color="primary"
                    aria-hidden="true"
                    tabIndex={-1}
                    size="large"
                >
                    <ErrorIconSvg></ErrorIconSvg>
                </StyledIconButton>
            )}
        </StyledInputField>
    )

    return (
        <Box
            style={{
                width: style && style.width ? style.width + 'px' : 'auto',
            }}
        >
            <Box>
                <InputLabel htmlFor={fieldId}>
                    <StyledLabel variant="subtitle2">{label}</StyledLabel>
                </InputLabel>
            </Box>
            {InputField}
        </Box>
    )
}
